import { defineMessages, useIntl } from 'react-intl';
import { Segment } from 'semantic-ui-react';

const messages = defineMessages({
  titleBlock: {
    id: 'Text',
    defaultMessage: 'Text',
  },
  descriptionBlock: {
    id: 'Select some of the typed text to display formatting options.',
    defaultMessage:
      'Select some of the typed text to display formatting options.',
  },
  accessibilityWarning: {
    id: 'Empty text blocks cause accessibility errors. For spacing, use the specific spacing block.',
    defaultMessage:
      'Empty text blocks cause accessibility errors. For spacing, use the specific spacing block.',
  },
  attention: {
    id: 'Attention:',
    defaultMessage: 'Attention:',
  },
});

const MarkdownIntroduction = (props) => {
  const intl = useIntl();

  return (
    <div>
      <header className="header pulled">
        <h2>{intl.formatMessage(messages.titleBlock)}</h2>
      </header>

      <Segment secondary>
        <p>{intl.formatMessage(messages.descriptionBlock)}</p>
      </Segment>
      <Segment color="purple">
        <strong>{intl.formatMessage(messages.attention)}</strong>{' '}
        {intl.formatMessage(messages.accessibilityWarning)}
      </Segment>
    </div>
  );
};

export default MarkdownIntroduction;
